import React from "react";

const AppML_Home = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Home</h1>
      <p>This is the AppML Home page content.</p>
    </div>
  );
};

export default AppML_Home;
